<template>
    <div class="resource">
        <div v-if="check=='march'" id="check">
            <p>
                <i class="el-icon-loading loading"></i>
            </p>
            <p>请稍等，资源正在加载中...
            </p>
            <p>如出现错误请多尝试几次或者换用其他入口</p>
            <p>如不能正常使用请告知客服修复</p>
        </div>
        <div v-else-if="check=='nonentity'">
            <p>
                <i class="el-icon-warning-outline loading"></i>
            </p>
            <p>请先安装开心图书馆专用插件再进行访问资源</p>
            <p>如已经安装过还提示本页面，请按教程删除旧版本升级新版本</p>
            <p>安装插件地址：<a :href="help_url">{{help_url}}</a></p>
        </div>
        <div id="astrict" v-show="false">
            <p>
                <i class="el-icon-lock loading"></i>
            </p>
            <p v-if="check_user_condition==1">
                您访问的资源要求用户组为&nbsp;:&nbsp;
                <span v-if="check_user_condition==1" style="color:red">{{all_group}}</span>
                </p>
            <p v-if="check_user_condition==1">但您当前所在的用户组为&nbsp;:&nbsp;<span style="color:red">{{group}}</span></p>
            <p v-if="check_user_condition==1">
                请&nbsp;<a href="/main">返回资源列表</a>&nbsp;选择属于您的权限组的资源
                <span class="occupied"></span>
                或&nbsp;<a href="/pay">升级会员组</a>&nbsp;后再进行访问</p>
            <p v-if="check_user_condition==2">您的会员权限已到期, 请点"充值与续费"进行充值后继续使用</p>
            <p v-if="check_user_condition==2"><a href="/main">返回资源列表</a><span class="occupied"></span><a href="/pay">充值与续费</a></p>
        </div>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                status: true,
                check: "march",
                help_url: null,
                all_group: null,
                group: null,
                check_user_condition: null
            }
        },
        created() {
            var ht = document.location.protocol;
            var ip = window.location.host
            this.help_url = `${ht}//${ip}/help.html`
            var code = this.$route.query.code
            localStorage.setItem("rescode", code);
            if (code){
                this.request_user_condition()
                var nn = sessionStorage.getItem(code)
                if (nn <= 1) {
                    this.$router.push({"path": "/main"})
                }else if (nn) {
                    sessionStorage.setItem(code, nn-1)
                }else{
                    sessionStorage.setItem(code, 4)
                }
            }else{
                this.$router.push({"path": "/main"})
            }
        },
        mounted() {
            setTimeout(() => {
                if (document.getElementById("check")) {
                    this.check = 'nonentity'
                }
            }, 3000)
        },
        methods: {
            request_user_condition () {
                let param = new URLSearchParams();
                param.append("code", this.$route.query.code);
                this.$http.postUserCondition(param).then(resp=>{
                    if (resp.code==402){
                        this.check_user_condition = 1
                        this.all_group = resp.all_group
                        this.group = resp.group
                    }else if (resp.code==403) {
                        this.check_user_condition = 2
                    }else if (resp.code==404) {
                        this.$message.error('登录信息失效，请重新登陆！')
                        localStorage.removeItem('login_info')
                        this.$router.push({path: '/login'})
                    }
                })
            }
        }
    }
</script>
<style scoped>
    .resource {
        text-align: center;
        font-size: 16px;
        font-weight: 600;
        margin-top: 100px;
    }

    .resource p {
        margin-top: 20px;
    }

    .loading {
        font-size: 40px;
    }

    .load {
        display: inline-block;
        width: 20px;
        text-align: left;
    }

    .occupied {
        padding: 0 20px;
    }
</style>